<template>
  <div id="contenedor-listado-desktop">
    <v-data-table
      :headers="headers"
      :items="listadoLicitaciones"
      :server-items-length="serverItemsLength"
      :options.sync="optionsSync"
      :loading="cargando"
      loading-text="Cargando licitaciones..."
      no-data-text="No hay licitaciones para los filtros seleccionados.">
      <template v-slot:[`item.numero`]=" { item }">
        <router-link
        :to="{name: 'licitacion', params: { idLicitacion: item.id }}">
          {{ item.numero }}
        </router-link>
      </template>
      <template v-slot:[`item.tipo`]="{ item }">
        <v-chip
        dark
        :color="getTextoyColor(item.tipo).color">
          <span>{{ getTextoyColor(item.tipo).texto }}</span>
        </v-chip>
      </template>
      <template v-slot:[`item.estadoDerivado`]="{ item }">
        <v-chip
          small
          dark
          :color="getEstadoDerivadoMeta(item.estadoDerivado).color">
          {{ getEstadoDerivadoMeta(item.estadoDerivado).texto }}
        </v-chip>
      </template>
      <template v-slot:[`item.siguienteEvento`]="{ item }">
        <div class="d-flex flex-column">
          <span class="caption font-weight-medium">
            {{ getTextoSiguienteEvento(item.siguienteEvento) }}
          </span>
          <span
            v-if="item.siguienteEvento && item.siguienteEvento.fechaHora"
            class="caption"
            :class="getClaseUrgenciaEvento(item.siguienteEvento.fechaHora)">
            {{ getTextoFechaEvento(item.siguienteEvento.fechaHora) }}
          </span>
        </div>
      </template>
      <template v-slot:[`item.totalParticipantes`]="{ item }">
        <v-chip small outlined color="secondary">
          {{ item.totalParticipantes || 0 }}
        </v-chip>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :licitacion="item"></opciones>
      </template>
      <template v-slot:[`item.fechaConvocatoria`]="{ item }">
        <!-- <fecha-humano :fecha="new Date(item.fechaConvocatoria)"></fecha-humano> -->
          {{ formatFechaLocal(item.fechaConvocatoria) }}
      </template>
      <!-- <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template> -->
      <template v-slot:[`item.objeto`]="{ item }">
        <cortar-texto
        :texto="item.objeto">
        </cortar-texto>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CortarTexto from '@/components/CortarTextos.vue';
import Opciones from './Opciones.vue';
// import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoLicitacionesDesktop',
  props: {
    listadoLicitaciones: {
      type: Array,
      required: true,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
    serverItemsLength: {
      type: Number,
      default: 0,
    },
    options: {
      type: Object,
      default: () => ({
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      }),
    },
  },
  components: {
    Opciones,
    CortarTexto,
    // FechaHumano,
  },
  data() {
    return {
      tiposLicitacion: [
        { id: 1, texto: 'Pública', color: '#43BC82' },
        { id: 2, texto: 'Por invitación', color: '#1E88E5' },
      ],
      headers: [
        {
          text: 'Número de Licitación',
          align: 'start',
          value: 'numero',
          width: '200',
          sortable: true,
        },
        { text: 'Objeto', value: 'objeto', sortable: false },
        { text: 'Estado operativo', value: 'estadoDerivado', sortable: false },
        { text: 'Próximo evento', value: 'siguienteEvento', sortable: false },
        { text: 'Tipo', value: 'tipo', sortable: false },
        { text: 'Participantes', value: 'totalParticipantes', sortable: false },
        {
          text: 'F. Convocatoria', align: 'center', value: 'fechaConvocatoria', sortable: true,
        },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  methods: {
    formatFechaLocal(fecha) {
      if (!fecha) return '';

      // Evita desfases por zona horaria cuando la API envía solo fecha (YYYY-MM-DD).
      if (typeof fecha === 'string') {
        const soloFechaMatch = fecha.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (soloFechaMatch) {
          const [, anio, mes, dia] = soloFechaMatch;
          return new Date(Number(anio), Number(mes) - 1, Number(dia)).toLocaleDateString();
        }
      }

      const parsed = new Date(fecha);
      if (Number.isNaN(parsed.getTime())) return '';
      return parsed.toLocaleDateString();
    },
    getTextoyColor(tipo) {
      return this.tiposLicitacion.find((tipoLicitacion) => tipo === tipoLicitacion.id);
    },
    getEstadoDerivadoMeta(estadoDerivado) {
      const estados = {
        BORRADOR: { texto: 'Borrador', color: '#9E9E9E' },
        PROGRAMADA: { texto: 'Programada', color: '#5C6BC0' },
        CON_PARTICIPANTES: { texto: 'Con participantes', color: '#00897B' },
        EN_EVALUACION: { texto: 'En evaluacion', color: '#FB8C00' },
        FALLO_CAPTURADO: { texto: 'Fallo capturado', color: '#8E24AA' },
        LISTA_PARA_CONTRATAR: { texto: 'Lista para contratar', color: '#3949AB' },
        CONTRATADA: { texto: 'Contratada', color: '#2E7D32' },
      };

      return estados[estadoDerivado] || { texto: estadoDerivado || 'Sin estado', color: '#607D8B' };
    },
    getTextoSiguienteEvento(siguienteEvento) {
      if (!siguienteEvento || !siguienteEvento.eventoTexto) return 'Sin evento';
      return siguienteEvento.eventoTexto;
    },
    getTextoFechaEvento(fechaHora) {
      const fechaEvento = new Date(fechaHora);
      if (Number.isNaN(fechaEvento.getTime())) return 'Fecha invalida';

      const hoy = new Date();
      const diffMs = fechaEvento.getTime() - hoy.getTime();
      const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      const fechaTexto = fechaEvento.toLocaleDateString();

      if (dias < 0) {
        return `${fechaTexto} (vencido)`;
      }

      if (dias === 0) {
        return `${fechaTexto} (hoy)`;
      }

      if (dias === 1) {
        return `${fechaTexto} (manana)`;
      }

      return `${fechaTexto} (en ${dias} dias)`;
    },
    getClaseUrgenciaEvento(fechaHora) {
      const fechaEvento = new Date(fechaHora);
      if (Number.isNaN(fechaEvento.getTime())) return 'grey--text';

      const ahora = new Date();
      const diffMs = fechaEvento.getTime() - ahora.getTime();
      const horas = diffMs / (1000 * 60 * 60);

      if (horas < 0) return 'red--text text--darken-2';
      if (horas <= 48) return 'orange--text text--darken-2';
      return 'green--text text--darken-2';
    },
  },
  computed: {
    optionsSync: {
      get() {
        return this.options;
      },
      set(value) {
        this.$emit('update:options', value);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
